// ---------------------------------------------------------------------------
// country.content.ts — Per-country translated content for country landing pages.
// English text lives in seo-country.data.ts configs; this file holds non-English
// locale overrides keyed by country slug (us, uk, uae, thailand, australia).
// ---------------------------------------------------------------------------
import type { SupportedLocale } from '../i18n.config';
import { COUNTRY_AR } from './country.ar';
import { COUNTRY_TH } from './country.th';
import { COUNTRY_ES } from './country.es';
import { COUNTRY_FR } from './country.fr';
import { COUNTRY_DE } from './country.de';
import { COUNTRY_JA } from './country.ja';
import { COUNTRY_ZH } from './country.zh';
import { COUNTRY_HI } from './country.hi';

export interface CountryText {
  countryName: string;
  heroTitle: string;
  heroSubtitle: string;
  statsLabels: string[];
  features: Array<{ title: string; description: string }>;
  complianceTitle: string;
  complianceItems: Array<{ name: string; description: string }>;
  testimonial: { quote: string; role: string; hotel: string };
  faqItems: Array<{ question: string; answer: string }>;
  ctaTitle: string;
  ctaSubtitle: string;
}

export const COUNTRY_TRANSLATIONS: Partial<Record<SupportedLocale, Record<string, CountryText>>> = {
  ar: COUNTRY_AR,
  th: COUNTRY_TH,
  es: COUNTRY_ES,
  fr: COUNTRY_FR,
  de: COUNTRY_DE,
  ja: COUNTRY_JA,
  zh: COUNTRY_ZH,
  hi: COUNTRY_HI,
};
